import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import LoaderSubmitBtn from 'components/blocks/Buttons/LoaderSubmitBtn';
import DateDouble from 'components/blocks/Inputs/DateDouble';
import useDeltaStore from 'stores/useDeltaStore';
import '../Forms.scss';
import './BuscadorDelta.scss';

interface IProps {
  handleFilterPat: (values: any) => void;
  loading: boolean;
}

const BuscadorConBajaPendiente: React.FC<IProps> = ({ handleFilterPat, loading }) => {
  const patFilterValues = useDeltaStore((s) => s.patFilterValues);
  const [resetKey, setResetKey] = useState(0);
  const {
    handleSubmit, reset, watch, formState: { errors },
    register, trigger, setValue,
  } = useForm({ defaultValues: patFilterValues || {} });

  const handleReset = () => {
    reset({ validation: '2', remitted: '2' });
    setResetKey((k) => k + 1);
  };

  return (
    <form
      className="delta-buscador-form form--simple-styled searcher"
      onSubmit={handleSubmit(handleFilterPat)}
    >
      <div className="delta-buscador-body">

        <div className="delta-buscador-field">
          <label htmlFor="validation" className="delta-buscador-label">Validación</label>
          <select id="validation" className="delta-buscador-select" {...register('validation')}>
            <option value="2">Todos</option>
            <option value="0">Correcta</option>
            <option value="1">Incorrecta</option>
          </select>
        </div>

        <DateDouble
          key={resetKey}
          register={register}
          errors={errors}
          label="Fecha de baja"
          watch={watch}
          trigger={trigger}
          setValue={setValue}
        />

      </div>

      <div className="delta-buscador-actions">
        <button
          type="button"
          className="delta-buscador-btn-clear"
          onClick={handleReset}
        >
          Borrar
        </button>
        <LoaderSubmitBtn loading={loading} text="Buscar" />
      </div>
    </form>
  );
};

export default BuscadorConBajaPendiente;
